module.exports = __webpack_public_path__ + "media/PAG66-05.fbfa0b13.mp3";